import React from 'react';
import Footer from '../containers/Footer/Footer';
import Contact from '../containers/Contact/Contact';
import Laluv from '../containers/Idroflog/Laluvit';
import LalAccordion from '../components/LalAccordion';

const laluvit = () => {
  return (
    <>
      <div className="product-page">
        <Laluv />
        <LalAccordion />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default laluvit;
